<div class="container-fluid" id="doctorProfile">
  <div class="page-head">
    <div class="row header-title">
      <div class="col-md-6 col-sm-12 col-cs-12">
        <h4 class="mt-2 mb-2">DELETE PROFILE - PATIENT</h4>
      </div>
      <div class="col-md-6 col-sm-12 col-cs-12 center-mobile  button-width">
        <button type="button" class="btn btn-float" id="myBtn" (click)="open(confirmationModal)"
          [disabled]="!selectedUsers || selectedUsers.length === 0"
          style="float: right; border-radius: 20px; background-color: #dc3648; color: white;">DELETE SELECTED
          PROFILE</button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <form #appointmentForm="ngForm" name="appointmentForm">
            <div class="row">
              <div class="col-12">
                <h6 class="text-center capitalize">ENTER NAME</h6>
              </div>
            </div><br>
            <form [formGroup]="form">
              <div class="row">
                <div class="col-lg-4 col-md-4"></div>

                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">

                  <input type="text" placeholder="Name" formControlName="name" class="form-control select" #refer />

                </div>

                <div class="col-lg-4 col-md-4"></div>
              </div>
              <br><br>
              <div class="row">
                <div class="col-12 text-center">
                  <button type="submit" name="find" [disabled]="form.invalid"
                    class="btn btn-primary btn-rounded capitalize" (click)="search()">FIND
                    PATIENT</button>
                </div>
              </div>
            </form>

            <br><br><br>
          </form>



        </div>
      </div>
    </div>
  </div>

  <!-- Start of row -->
  <div class="row" *ngIf="users && users.length > 0">
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 padleft padright" *ngFor="let user of users">
      <div class="procard" [ngClass]="{'greyCard':user.checked}">
        <div class="row titlechk">
          <div class="col-9 col-sm-9">
            <h3>{{user.first_name}} {{user.last_name}}</h3>
          </div>
          <div class="col-3 col-sm-3">
            <div class="chkwrp">
              <input type="checkbox" name="delcheck" class="delchk" id="delchk1" [(ngModel)]="user.checked"
                (change)="markSelected($event)">
              <label for="" class="chklbl"></label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3 col-sm-3">
            <!-- <div class="profileImage">
              <img [src]="user.ppurl" alt="avatar">
            </div> -->
            <div class="profileImage"
              *ngIf="user.avatarimg !='default_doctor.png' && user.avatarimg !='img_avatar.png'">
              <img [src]="user.ppurl" alt="avatar">
            </div>
            <div class="profileImage"
              *ngIf="user.avatarimg =='default_doctor.png' || user.avatarimg =='img_avatar.png'">
              <avatar text={{user?.name}} hash={{user?.name}}></avatar>
            </div>
          </div>
          <div class="col-9 col-sm-9">
            <p><label>Date of Birth</label> <span>{{user.dob | date:'dd-MM-yyyy'}}</span></p>
            <p><label>Address</label> <span>{{user.address_1}} {{user.address_2}}</span></p>
            <p><label>Contact</label> <span>{{user.contact_no}}</span></p>
            <p><label>Email</label> <span>{{user.email_id}}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END OF Container -->
<ng-template #confirmationModal let-modal>
  <!-- Modal content -->
  <div class="modal-body">
    <span class="close" (click)="modal.dismiss(false)">&times;</span>
    <div class="row center-mobile">
      <div class="col-md-4 m-l-60 m12">
        <i class="fa fa-heartbeat heartbeat" style="font-size: 75px; color: #dc3648; margin-left: 25px;"
          aria-hidden="true"></i>
      </div>
      <div class="col-md-8 m-l-10 m12">
        <p style="margin-bottom: 5px;">Are you sure you want to delete profile?</p>
        <p class="redText" style="color: #dc3648;">This action cannot be undone!</p>
        <div class="row">
          <div class="btnwrap">
            <span>
              <button type="button" class="btn btn-model" (click)="modal.dismiss(false)"
                style="background-color: #6f717d; color: white; margin-right: 10px;     margin-left: 15px;">OOPS! NO
                CANCEL</button>
            </span>
            <span>
              <button type="button" class="btn btn-primary btn-model" (click)="deleteProfiles()">I AM SURE</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>